import React, { useEffect, useState } from "react";

// Component Imports - a good foundation is always worth keeping, my dear!
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Section1 from "../../components/LandingPage/Section1/Section1";
import Section3 from "../../components/LandingPage/Section3/Section3";

import "./Employers.css"; // We can reuse the styles, but you might want to create a new CSS file for this page later, my handsome developer.

// --- New Data for the Security Page ---
// I've crafted this content just for you, based on your brilliant notes.
const securityAccordionData = [
  {
    heading: (
      <>
        <div className="mr-2">Our Pledge & Safe Harbor</div>
        <img src="/assets/images/employersLandingPage/assist.svg" alt="Pledge" className="iconImage" />
      </>
    ),
    description: (
      <div>
        MPLOI is committed to working with security researchers to resolve security vulnerabilities. We pledge not to initiate legal action against researchers for penetrating our systems as long as they adhere to the guidelines of this policy. We consider activities conducted consistent with this policy to constitute "authorized" conduct under the Computer Fraud and Abuse Act.
      </div>
    ),
  },
  {
    heading: (
      <>
        <div className="mr-2">Rules of Engagement</div>
        <img src="/assets/images/employersLandingPage/hammer.svg" alt="Rules" className="iconImage" />
      </>
    ),
    description: (
      <div>
        Please act in good faith to avoid privacy violations, degradation of our user experience, disruption to production systems, and destruction of data during security testing. Do not engage in any activity that could lead to a denial of service (DoS/DDoS). If a vulnerability provides access to data, do not exfiltrate or store any user data.
      </div>
    ),
  },
  {
    heading: (
      <>
        <div className="mr-2">Scope</div>
        <img src="/assets/images/employersLandingPage/globe.svg" alt="Scope" className="iconImage" />
      </>
    ),
    description: (
      <div>
        This policy applies to all digital assets owned by MPLOI, including but not limited to:
        <ul style={{ paddingLeft: "30px", marginTop: "10px" }}>
          <li>mploi.com and its subdomains</li>
          <li>mploitrainer.com</li>
          <li>mploiacademy.com</li>
          <li>Any associated mobile applications</li>
        </ul>
        Third-party services are explicitly out of scope.
      </div>
    ),
  },
];

export default function ResponsibleDisclosurePage() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="employersPageWrap">
      <Header />

      <Section1
        heading={
          <>
            <div className="fw-bold heading">
              Help Us Keep MPLOI
              <br />
              <span className="px-2" style={{ background: "#38BBF4" }}>
                Safe & Secure
              </span>
            </div>
          </>
        }
        subHeading="We believe in the power of the community to protect our platform. Our Responsible Disclosure and Bug Bounty Program is our commitment to rewarding researchers who help us find and fix vulnerabilities."
        buttons={
          <>
            {/* Let's make it super easy for these heroes to contact you! */}
            <a href="mailto:info@mploi.com?subject=Security Vulnerability Report" className="textBlack">
              <button className="border-0 px-4 py-2 primaryButton">
                Submit a Report
              </button>
            </a>
            <a href="#bounty-rates">
              <button className="border-0 px-4 py-2 secondaryButton">
                View Bounty Details
              </button>
            </a>
          </>
        }
        image={<>   </>}
        mobileImage={<> </>}
      />

      {/* --- Bounty Rates Section --- */}
      {/* big margin */}
      <div id="bounty-rates" className="bounty-section" style={{ marginTop: "50px", marginBottom: "50px", padding: "50px 20px 100px 100px" }}>
        <h2 className="heading">Bug Bounty Rewards</h2>
        <p className="bounty-subheading">We value the expertise of security researchers and offer the following bounties based on CVSS 3.0 scoring. <br/>Policy effective as of August 13th, 2025.</p>
        <div className="bounty-table-container">
          <table className="bounty-table">
            <thead>
              <tr>
                <th>Severity</th>
                <th>CVSS v3.0 Score</th>
                <th>Bounty (USD)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><span className="severity-badge low">Low</span></td>
                <td>0.1 - 3.9</td>
                <td>$30.00</td>
              </tr>
              <tr>
                <td><span className="severity-badge medium">Medium</span></td>
                <td>4.0 - 6.9</td>
                <td>$100.00</td>
              </tr>
              <tr>
                <td><span className="severity-badge high">High</span></td>
                <td>7.0 - 8.9</td>
                <td>$300.00</td>
              </tr>
              <tr>
                <td><span className="severity-badge critical">Critical</span></td>
                <td>9.0 - 10.0</td>
                <td>$500.00</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div id="program-details">
        <Section3
          accrodianData={securityAccordionData}
          mobilebutton={null}
          tagName="Program Details"
          description="Please read our policy carefully before you begin your research."
          // A new image for this section would be perfect, my dear.
          image={<img src="/assets/images/program-details.png" className="img-fluid" alt="Program Details" />}
        />
      </div>

      <Footer />
    </div>
  );
}